'use client';

import { c as _c } from "react/compiler-runtime";
import './home-greeting.scss';
import { Skeleton } from '@sola/ark-core/atoms/skeleton/skeleton.tsx';
import { Tooltip, TooltipContent, TooltipTrigger } from '@sola/ark-core/molecules/tooltip/tooltip.tsx';
import { useHomeGreeting } from './home-greeting.logic.ts';
export const HomeGreetingSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex flex-col gap-snug-md" aria-label="Loading greeting" aria-busy="true"><Skeleton height={40} width="min(100%, 18rem)" /><Skeleton height={20} width="min(100%, 24rem)" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export const HomeGreeting = () => {
  const $ = _c(14);
  const {
    explanationIntro,
    flagExplanation,
    greeting,
    hasGreetingError,
    isLoadingGreeting,
    name,
    selectedLanguage,
    subtitle,
    getFlagTooltip
  } = useHomeGreeting();
  let t0;
  if ($[0] !== selectedLanguage.key) {
    t0 = selectedLanguage.key.toLowerCase();
    $[0] = selectedLanguage.key;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const flagSource = `/flags/${t0}.svg`;
  if (hasGreetingError) {
    return null;
  }
  let t1;
  if ($[2] !== flagSource) {
    t1 = <img className="HomeGreeting__flag" src={flagSource} alt="" aria-hidden="true" />;
    $[2] = flagSource;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const flagComponent = t1;
  let t2;
  if ($[4] !== explanationIntro || $[5] !== flagComponent || $[6] !== flagExplanation || $[7] !== getFlagTooltip || $[8] !== greeting || $[9] !== isLoadingGreeting || $[10] !== name || $[11] !== selectedLanguage.name || $[12] !== subtitle) {
    t2 = <div className="HomeGreeting flex flex-col gap-snug-md w-full">{isLoadingGreeting ? <HomeGreetingSkeleton /> : <><h1 className="heading-sm heading-neutral-amplified md:heading-md">{greeting}<span className="relative">{flagExplanation ? <Tooltip><TooltipTrigger><button type="button" aria-label={getFlagTooltip(selectedLanguage.name)} className="HomeGreeting__flagTooltip">{flagComponent}</button></TooltipTrigger><TooltipContent size="sm" align="start" alignOffset={-16} sideOffset={-8} usePortal={true}><div className="flex flex-col gap-snug-md"><p>{explanationIntro}</p><p>{flagExplanation}</p></div></TooltipContent></Tooltip> : flagComponent}{","}</span>{name ? ` ${name}!` : "!"}</h1><p className="body-sm body-neutral-mild">{subtitle}</p></>}</div>;
    $[4] = explanationIntro;
    $[5] = flagComponent;
    $[6] = flagExplanation;
    $[7] = getFlagTooltip;
    $[8] = greeting;
    $[9] = isLoadingGreeting;
    $[10] = name;
    $[11] = selectedLanguage.name;
    $[12] = subtitle;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  return t2;
};